module.exports = __webpack_public_path__ + "img/logoblue.2fe55f51.png";